import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import RecentCaptures from './components/RecentCaptures';
import TopOrganizations from './components/TopOrganizations';
import ZoneDetails from './components/ZoneDetails';
import InfoPage from './components/InfoPage';
import { zones } from './data/mock';
import './App.css';

export default function App() {
  return (
    <Router>
      <div className="main-container">
      <header>
        <div className="logo-title-row">
          <img
            src="/logo.webp"
            alt="NXT Logo"
            height="58"
            style={{
              marginRight: "19px",
              verticalAlign: "middle",
              userSelect: "none",
              filter: "drop-shadow(0 2px 18px #e43c9255)"
            }}
            draggable={false}
          />
          <span className="title-text">Strefy Wpływów</span>
        </div>
        <nav>
          <NavLink to="/" end>Ostatnie przejęcia</NavLink>
          <NavLink to="/top">Liderzy wpływów</NavLink>
          <NavLink to="/info">Jak to działa?</NavLink>
        </nav>
      </header>

        <Routes>
          <Route path="/" element={<RecentCaptures zones={zones} />} />
          <Route path="/top" element={<TopOrganizations zones={zones} />} />
          <Route path="/strefa/:name" element={<ZoneDetails zones={zones} />} />
          <Route path="/info" element={<InfoPage />} />
        </Routes>
        <footer>
          <small>© 2025 NXT</small>
        </footer>
      </div>
    </Router>
  );
}
